const localStorageKey = "closer-classic-widget-position";

const state = (() => {
  const _state = {
    top: 25,
    left: 25,
    collapsed: false,
  };
  try {
    const saved = JSON.parse(localStorage.getItem(localStorageKey) || "{}");
    if ("top" in saved) {
      _state.top = saved.top;
    }
    if ("left" in saved) {
      _state.left = saved.left;
    }
    if ("collapsed" in saved) {
      _state.collapsed = saved.collapsed;
    }
  } catch (e) {}
  const _save = () =>
    localStorage.setItem(localStorageKey, JSON.stringify(_state));
  return {
    get top() {
      return _state.top;
    },
    set top(val: number) {
      _state.top = val;
      _save();
    },
    get left() {
      return _state.left;
    },
    set left(val: number) {
      _state.left = val;
      _save();
    },
    get collapsed() {
      return _state.collapsed;
    },
    set collapsed(val: boolean) {
      _state.collapsed = val;
      _save();
    },
  };
})();

export const wrapper = document.createElement("div");
wrapper.style.position = "fixed";
wrapper.style.top = `${state.top}px`;
wrapper.style.left = `${state.left}px`;
// wrapper.style.width = "382px";
wrapper.style.border = "1px solid red";
wrapper.style.overflow = "hidden";
wrapper.style.pointerEvents = "all";
wrapper.style.zIndex = "999";
wrapper.style.backgroundColor = "white";

const header = document.createElement("div");
header.style.width = "100%";
header.style.height = "20px";
header.style.borderBottom = "1px solid red";
header.style.color = "red";
header.style.cursor = "move";
header.textContent = "Classic Widget";
wrapper.appendChild(header);

export const chat = document.createElement("div");
chat.id = "some-random-chat-container-id";
setInterval(() => {
  chat.style.height = `${state.collapsed ? 0 : 500}px`;
}, 1000);
wrapper.appendChild(chat);

header.addEventListener("mousedown", (ev) => {
  ev.stopPropagation();
  ev.preventDefault();

  const start = { x: ev.clientX, y: ev.clientY };
  const orig = { x: wrapper.offsetLeft, y: wrapper.offsetTop };
  const delta = { x: start.x - orig.x, y: start.y - orig.y };

  const onMouseMove = (ev: MouseEvent) => {
    ev.stopPropagation();
    wrapper.style.left = ev.clientX - delta.x + "px";
    wrapper.style.top = ev.clientY - delta.y + "px";
  };
  const onMouseUp = (ev: MouseEvent) => {
    ev.stopPropagation();
    document.removeEventListener("mouseup", onMouseUp, true);
    document.removeEventListener("mousemove", onMouseMove, true);
    const left = ev.clientX - delta.x;
    const top = ev.clientY - delta.y;
    if (left === state.left && top === state.top) {
      state.collapsed = !state.collapsed;
    } else {
      state.top = top;
      state.left = left;
    }
  };

  document.addEventListener("mousemove", onMouseMove, true);
  document.addEventListener("mouseup", onMouseUp, true);
});

export const classicChat = chat;
